import React from 'react';
import './style/index.scss';

interface LoadingIndicatorProps {
    className?: string;
}

export class LoadingIndicator extends React.Component<LoadingIndicatorProps> {

    render(): React.ReactNode {
        return (
            <div className={`loading-indicator ${this.props.className}`}>
                <svg className="loading-indicator__circle" viewBox="25 25 50 50">
                    <circle
                        className="loading-indicator__circle-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                    />
                </svg>
            </div>
        );
    }
}

export default { LoadingIndicator };